export const data1 = {
    title: '智慧病案解决⽅案',
    type: '1',
    img: 'img_solution1',
    img2: 'solution1',
    img3:'img1',
    content: [
        { type: 'title', value: '⽅案背景' },
        {
            type: 'text', value: '近年来，随着医院管理的⽇益规范化和医疗⾏业的深⼊发展，对病案资料的管理也提出了更⾼的信息化建设要求。病案资料不仅是医院医疗质量、技术⽔平和管理⽔平的综合评价依据是医疗⼯作的全⾯记录，能够客观地反映疾病诊断、治疗及其转归的全过程。因此，为了更好地适应医疗卫⽣体制的深化改⾰发展，病案的全流程管理与数据统计⼯作显得尤为重要。'
        },
        { type: 'title', value: '需求分析' },
        { type: 'text', value: '病历信息管理挑战：更新缓慢影响效率' },
        {
            type: 'text2', value: '在医院病案统计管理⼯作中，病历信息的错误、遗漏以及病案流转过程的监管不及时，这些问题均会导致病案归档效率低下。'
        },
        { type: 'text', value: '病案流转⻛险：漏收、错收与遗失隐患' },
        { type: 'text2', value: '医院各部⻔间流转病案时，存在较⾼的病案漏收、错收和遗失⻛险。⼀旦出现问题，往往⽆法进⾏事后追踪，对病案的安全构成严重威胁。' },
        { type: 'text', value: '病案信息统计难题：⼈⼒与技术的双重挑战' },
        {
            type: 'text2', value: '由于医院病案专职⼈员配备不⾜，加上统计⽅式落后，病案信息的统计管理⼯作受到极⼤影响，同时统计质量也难以得到保证。'
        },
        { type: 'title', value: '⽅案介绍' },
        {
            type: 'text', value: '传统的病案管理⽅式已逐渐显现出其局限性，难以满⾜现代医疗机构对⾼效、精准管理的需求。普康智慧病案解决⽅案正是针对这⼀问题⽽设计，旨在提升病案管理的整体效率。该⽅案充分利⽤⼤数据技术与物联⽹技术的优势，实现了病案信息的数字化、标准化处理，以及全流程的示踪管理。这不仅⼤⼤提升了病案室的⼯作效率，还显著提⾼了归档病案的使⽤率和管理质量。通过普康智慧病案解决⽅案，我们致⼒于推动医院病案管理向更加精细化、信息化的⽅向发展，以适应医疗⾏业快速发展的步伐'
        },
        { type: 'title', value: '⽅案亮点' },
        { type: 'text', value: '病历报表明细化' },
        {
            type: 'text2', value: '针对医院不同部⻔对病例有不同的侧重点和要求。细化设计相应的病例报表模板使之符合相关科室的要求，并保障能有效实现⽉、季、年统计报表的要求。'
        },
        { type: 'text', value: '全流程病案追踪' },
        {
            type: 'text2', value: '针对医院纸质病案的流转管理，普康智慧病案解决⽅案采取管理纸质病案的实时流通状态，帮助医院实现了病案流向管理的规范化、系统化、数字化。'
        },
        { type: 'title', value: '⽅案价值' },
        { type: 'text', value: '保障医院整体⼯作效率提升' },
        { type: 'text2', value: '普康智慧病案解决⽅案在帮助医院开展病案统计和病案示踪的信息化管理的过程中，有效把控病案录⼊、建档、调取、查找等⽅⾯的⼈⼯操作，以保障医院⼈⼒成本得到有效节省。在此过程中，保障病案质量以满⾜医院医疗项⽬临床、管理等⽅⾯的要求。' },
        { type: 'text', value: '助推缓和紧张的医患关系' },
        {
            type: 'text2', value: '借助于普康智慧病案解决⽅案病案统计和病案示踪的优势，有效将患者患病和病案流转的全部过程具现出来，进⼀步从实际出发规范化医院医务⼈员的⼯作流程，保护医⽣以及医院的利益。'
        },
        { type: 'title', value: '信息化平台' },
        { type: 'img', value: 'detail1' }
    ]
}
export const data2 = {
    title: '医疗质控解决⽅案',
    type: '2',
    img: 'img_solution2',
    img2: 'solution2',
    img3: 'img2',
    content: [
        { type: 'title', value: '⽅案背景' },
        {
            type: 'text', value: '近年来，在‘国考’及其他相关政策的指引下，国家医保局明确提出了加快推进医保结算清单的落地使⽤，并对医保结算清单的各项填写要求进⾏了详尽的说明和细致的指导。若填写不规范，不符合医保的标准，可能会⾯临医保拒付的⻛险，这将直接对医院的经济利益产⽣不利影响。同时，为了进⼀步提升医疗质量，国家卫⽣健康委、国家中医药局联合发布了《全⾯提升医疗质量⾏动计划（2023 - 2025）》，该计划特别强调了加强病案⾸⻚质量管理的重要性，要求提升病案⾸⻚的准确性，并重点落实病历内涵质量提升活动。'
        },
        { type: 'title', value: '需求分析' },
        { type: 'text', value: '病历与结算清单质量⻛险：规范性与准确性待提升' },
        {
            type: 'text2', value: '⽬前，国内绝⼤多数医⽣在⼊职培训前仅接受过相关基础知识的培训，对于病历和结算清单书写规范的了解尚不全⾯。由于⽇常医疗⼯作繁重，他们在这⽅⾯的知识学习相对较少，导致在病历与结算清单书写时很难保证质量。'
        },
        { type: 'text', value: '质量控制挑战：病历与结算清单问题频发' },
        {
            type: 'text2', value: '在填写病案⾸⻚、结算清单和病历的过程中，医⽣常常⾯临完整性和必填项逻辑性的挑战。结算清单尤为突出，病例⼊组准确率低，缺填、漏填、错填现象频发，这些问题往往导致病组的⾼编或低编。⽽医疗机构在病案专职⼈员的配备上普遍存在不⾜，加之监管过程繁琐、效率低下，使得病历和结算清单在质量控制⽅⾯⾯临较⼤的挑战。'
        },
        { type: 'text', value: '医疗数据信息化瓶颈：质控效率与准确性待提⾼' },
        {
            type: 'text2', value: '在病案⾸⻚、病历和结算清单的书写过程中，需要考虑的质控规则数量庞⼤，这对病案专职⼈员构成了巨⼤的压⼒。他们很难在短时间内完成⼤量⽂件的质量检验⼯作。同时，在编码映射过程中，由于容易出现混淆和逻辑错误，导致数据映射错误，降低了数据的准确性。此外，医疗数据信息化程度的不⾜还可能导致⽂书数据保存不到位或相关数据存储缺失等问题，进⼀步加剧了数据质量的⻛ 险。'
        },
        { type: 'title', value: '⽅案介绍' },
        {
            type: 'text', value: '普康医疗质控解决⽅案基于国考及相关病案、结算清单等书写规范⽂件，构建了庞⼤的质控标准知识库。普康医疗质控解决⽅案从‘医务⼈员- 患者 - 医院’三者的共同利益出发，设计了简便、合理的质控流程，以实现对医疗⽂件全⽅位的质量把控与评价。普康医疗质控解决⽅案不仅旨在提升医疗机构在病案⾸⻚、病历、结算清单等⽅⾯的质量控制⽔平，还致⼒于减轻病案专职⼈员的⽇常⼯作负担，从⽽推动医院向更加精细化、科学化的管理⽅向发展。'
        },
        { type: 'title', value: '⽅案亮点' },
        { type: 'text', value: 'AI智能质控平台' },
        { type: 'text2', value: '基于普康数据汇聚智能中⼼的AI计算引擎服务与数据挖掘技术，该平台⽆缝对接院内业务系统，⽣成⾼质量结构化的病历。通过先进的⽂本分析和NLP引擎技术，它能够精准读取病历中的潜在错误，确保病历信息的准确性。' },
        { type: 'text', value: '丰富的质控规则体系' },
        {
            type: 'text2', value: '依据国家及地⽅医疗质量评价体系，我们制定了数千条通⽤质控规则，覆盖病案⾸⻚、结算清单等600多项关键字段。此外，质控规则的配置具有⾼度的灵活性，可根据医院的特殊情况进⾏⾃主调整和优化。'
        },
        { type: 'text', value: '⾼效全⾯的质控流程' },
        {
            type: 'text2', value: '该平台整合了院内所有质控⻆⾊，依托医保知识库和病案知识库，实现了对病案⾸⻚、电⼦病历、结算清单的全⽅位质控。从事前预防、事中监控到事后审核，通过AI算法引擎实现医⽣书写病历时的实时质控，助⼒医院全⾯提升病案⾸⻚、电⼦病历、结算清单的质量评级。'
        },
        { type: 'title', value: '⽅案价值' },
        { type: 'text', value: '提升病历数据质量' },
        { type: 'text2', value: '实施全⾯数据监测、核查和上报机制，从源头上优化病案信息，推动病案管理数字化进程。' },
        { type: 'text', value: '降低医疗出错率' },
        { type: 'text2', value: '通过严谨的校验、预警和提示措施，有效降低医疗错误，有⼒保障患者的合法权益。' },
        { type: 'text', value: '减轻科室⼯作负担' },
        { type: 'text2', value: '采⽤机器+⼈⼯的质控⽅式，替代⼈⼯抽检，减轻科室⼯作负担，提升数据质量和效率。' },
        { type: 'text', value: '提升DRG/DIP分组准确性' },
        { type: 'text2', value: '预防⾼编、低编、错编和漏编等情况，提⾼病例准确分组率。' },
        { type: 'title', value: '信息化平台' },
        { type: 'img', value: 'detail2' }
    ]
}
export const data3 = {
    title: 'DRG/DIP解决⽅案',
    type: '3',
    img: 'img_solution3',
    img2: 'solution3',
    img3: 'img3',
    content: [
        { type: 'title', value: '⽅案背景' },
        {
            type: 'text', value: '⾃2021年底国家医保局印发《DRG/DIP⽀付⽅式改⾰三年⾏动计划》以来，我国正加快推进按疾病诊断相关分组/ 病种分值（DRG / DIP）⽀付⽅式改⾰的全覆盖。然⽽，在采⽤DRG / DIP付费⽅式后，医疗机构可能会⾯临增收不增利或收⽀不平衡的挑战。因此，医疗机构急需结合医保⽀付的新要求，适应DRG / DIP改⾰，实现精细化、科学化的管理。'
        },
        { type: 'title', value: '需求分析' },
        { type: 'text', value: '医保基⾦预付⻛险：总额难以预测' },
        {
            type: 'text2', value: '定点医疗机构每季度的医保预付总额受到医保部⻔的严格监管。若医疗费⽤超出预付总额，医疗机构将⾯临亏损的⻛险。'
        },
        { type: 'text', value: '⼊组异常挑战：收⽀受冲击' },
        {
            type: 'text2', value: 'DRG异常⼊组不仅可能导致医保⽀付减少或拒绝⽀付，还会直接影响医疗机构的合理收⼊和绩效分配等关键⽅⾯。'
        },
        { type: 'text', value: '病案量庞⼤：影响分组与分值效率' },
        {
            type: 'text2', value: '⾯对⼤规模的病案量，医疗机构的病案科室、医保部⻔以及质控部⻔都⾯临着巨⼤的考验，可能影响病案分组和分值计算的效率。'
        },
        { type: 'text', value: '病案编码压⼒上升：确保准确性' },
        {
            type: 'text2', value: '在DRG/DIP政策下，病案科需特别关注编码的准确性、完整性和正确性，这⽆疑增加了医疗机构编码⼈员的⼯作压⼒。'
        },
        { type: 'title', value: '⽅案介绍' },
        {
            type: 'text', value: '普康DRG/DIP解决⽅案是基于全国范围内DRG/DIP⽀付⽅式改⾰的推⾏，针对医院体系改⾰的需求⽽设计的。该⽅案旨在帮助医疗机构在医保DRG/ DIP⽀付⽅式改⾰带来的新环境下，加强病案质控、成本分析、费⽤控制、绩效考核以及服务质量管理等⽅⾯的⼯作，实现精细化与科学化管理。通过实施普康DRG / DIP解决⽅案，医疗机构可以更有效地提⾼医疗质量，并加强成本管控⼒度，从⽽确保在改⾰过程中能够稳步发展。'
        },
        { type: 'title', value: '⽅案亮点' },
        { type: 'text', value: 'DRG/DIP病案⾸⻚智能质控' },
        {
            type: 'text2', value: '通过智能系统快速定位病案⾸⻚数据质量问题，确保数据准确可靠，以满⾜DRG/DIP数据上报的严格要求，从⽽提升整体病案⾸⻚数据质量。'
        },
        { type: 'text', value: 'DRG/DIP分组智能优化助⼿' },
        { type: 'text2', value: '实时监控病例分组费⽤标准，及时发现超标情况，并引⼊费⽤追踪和智能⼊组⽅案推荐功能，助⼒医院实现分组管理的科学化与精细化。' },
        { type: 'text', value: 'DRG/DIP运营全景监管' },
        {
            type: 'text2', value: '采⽤多维度盈亏分析⽅法，包括全院、科室、医⽣、病种等层⾯，全⾯统计医院盈亏数据，为医院提供直观、量化的精细化运营管理和医保⽀付⽅式改⾰成果展示。'
        },
        { type: 'title', value: '⽅案价值' },
        { type: 'text', value: '增强⼊组准确性' },
        {
            type: 'text2', value: '依托普康⾃研分组器，结合医保规则库，构建统⼀的标准编码库与病种分值库。结合专业⼈员培训，确保病案⼊组准确率显著提升。'
        },
        { type: 'text', value: '优化医院运营决策' },
        {
            type: 'text2', value: '基于病种盈亏分析，精准识别问题领域，推动优势科室发展，协助医院研究并实施更优质的治疗⽅案。同时，有助于缩短平均住院⽇，提⾼医疗服务的整体运⾏效率。'
        },
        { type: 'text', value: '加强医院成本管理' },
        {
            type: 'text2', value: '通过分组预测、费⽤分析等多维度核算⼿段，实现对病案全流程的精细化成本管控。辅助医⽣进⾏精准、动态的医疗费⽤结构调整，从⽽提升医院的成本管控能⼒。'
        },
        { type: 'title', value: '信息化平台' },
        { type: 'img', value: 'detail3' }
    ]
}
export const data4 = {
    title: '医疗管理解决⽅案',
    type: '4',
    img: 'img_solution4',
    img2: 'solution4',
    img3: 'img4',
    content: [
        { type: 'title', value: '⽅案背景' },
        {
            type: 'text', value: '在新医改形势下，国家对于医疗质量的管理⽇益严格，致⼒于加快推进医疗服务价格改⾰和规范化管理，深化以公益性为导向的公⽴医院改⾰，并强化以公益性为导向的绩效考核。与此同时，随着⼈们健康意识的不断提⾼，对医疗服务的要求也⽇益严格，这推动了医院医疗质量管理⼯作向信息化、精细化、规范化⽅向不断发展。'
        },
        { type: 'title', value: '需求分析' },
        { type: 'text', value: '数据采集挑战：多系统协同与海量数据处理' },
        {
            type: 'text2', value: '在医疗质量管理⼯作中，数据采集是⼀⼤挑战。需要依据相关国家标准和医疗机构实际情况，建⽴系统指标体系。这涉及从重症监护、不良事件、⼿术麻醉等第三⽅系统中抽取数据，进⾏清洗和汇总，以⽣成相应的指标。多系统的集成与海量数据的处理给医疗质量管理⼯作带来了不⼩的考验。'
        },
        { type: 'text', value: '管理范畴⼴泛：多应⽤、跨科室的综合监管' },
        {
            type: 'text2', value: '医疗机构的管理范围⼗分⼴泛。需要结合国家标准制定相关指标的计算流程，监管不同单病种诊疗服务的规范，同时还需要管理不同科室的医疗服务以及医院医疗⽔平的发展。这种跨科室、多应⽤的综合监管要求医疗机构具备⾼度的组织协调能⼒和精细化管理能⼒。'
        },
        { type: 'text', value: '管理效率瓶颈：⼈⼝增⻓与数据复杂性' },
        {
            type: 'text2', value: '随着⼈⼝的⽇益增⻓和医疗数据的不断积累，医疗机构的医疗管理⼯作⽇益繁重。不同的指标标准、海量的数据和复杂的数据处理流程使得医务层和管理层需要耗费更多时间和精⼒来推动医疗质量⼯作的进⾏。因此，提⾼管理效率成为医疗机构亟待解决的问题。'
        },
        { type: 'title', value: '⽅案介绍' },
        {
            type: 'text', value: '普康医疗管理解决⽅案旨在减轻医院⽇常医疗质量管理的负担，提⾼管理效率。通过与重症监护、不良事件、⼿术麻醉等系统对接，实现全⽅位的指标监管、单病种质量管理、绩效考核以及医院等级评审功能。这⼀解决⽅案将帮助医疗机构降低医疗成本，显著提升医疗质量，并进⼀步增强其核⼼竞争⼒，从⽽在竞争激烈的医疗市场中脱颖⽽出。'
        },
        // { type: 'title', value: '⽅案亮点' },
        { type: 'title', value: '⽅案价值' },
        { type: 'text', value: '提升管理效率' },
        {
            type: 'text2', value: '普康医疗管理⽅案通过实现多系统⾃动化收集、清洗和分析医疗数据，助⼒医疗机构实时监测和评估医疗质量指标。该⽅案引⼊机器学习和NLP相关技术引擎，通过流程化的数据分析和报表展示功能，使医疗机构能够迅速识别医疗流程中的质量问题，并及时进⾏优化解决，从⽽显著提⾼服务质量。'
        },
        { type: 'text', value: '医疗应⽤⼴泛覆盖' },
        {
            type: 'text2', value: '普康医疗管理⽅案针对医疗机构各个环节、各个科室的临床质量、护理质量、医疗服务质量和医疗安全质量进⾏全⾯监控评估。这⼀功能帮助管理者全⾯了解医院的医疗服务⽔平和质量状况，为及时采取改进措施提供了有⼒⽀持。'
        },
        { type: 'text', value: '数据驱动的科学管理' },
        {
            type: 'text2', value: '普康医疗管理解决⽅案利⽤数据分析和图表展示功能，为管理层制定科学决策提供了重要参考。通过对指标数据进⾏趋势分析、医疗服务状况分析以及诊疗流程周期分析，该⽅案能够揭示海量数据背后的趋势、规律和异常，从⽽协助管理层制定有针对性的质量改进策略和⽬标。'
        },
        { type: 'text', value: '提升诊疗效率与质量' },
        {
            type: 'text2', value: '普康医疗管理解决⽅案具备监测患者在医疗过程中状态和治疗效果的能⼒。通过对患者数据的统计和分析，该⽅案帮助医疗机构评估相关诊疗措施的效果，并以此为依据优化临床路径，最终实现诊疗效率和质量的双重提升。'
        },
        { type: 'title', value: '信息化平台' },
        { type: 'img', value: 'detail4' }
    ]
}
export const data5 = {
    title: '数据上报解决⽅案',
    type: '5',
    img: 'img_solution5',
    img2: 'solution5',
    img3: 'img5',
    content: [
        { type: 'title', value: '⽅案背景' },
        {
            type: 'text', value: '近年来，为加强医疗质量安全管理，持续提升其科学化、精细化⽔平，并构建优质⾼效的医疗质量管理与控制体系，国家卫健委等官⽅机构提出了病案⾸⻚填报以及上报⾄国家医院质量监测系统（HQMS）等系统的具体要求。这些要求旨在加强对基层医疗机构的运营情况、⾏业数据的把控，以客观评价各省、各市、各医院的医改成效。因此，医疗机构⾯临着将病案⾸⻚相关⽂件数据上报⾄多个国家相关医疗信息平台的挑战，其中编码映射的复杂性尤为突出。'
        },
        { type: 'title', value: '需求分析' },
        { type: 'text', value: '多平台数据上报挑战：复杂性与准确性双重考验' },
        {
            type: 'text2', value: '医疗结构需将病案⾸⻚数据上报⾄多个平台，⾯临的⾸要挑战是各平台间病案⾸⻚字段和标准的不统⼀性。这导致医疗机构在执⾏不同上报任务时，需进⾏多次数据采集，且数据可⽤性低，增加了⼯作难度和复杂度。'
        },
        { type: 'text', value: '数据源分散：多系统整合难' },
        {
            type: 'text2', value: '医疗机构病案⾸⻚上报的数据通常来源于多个业务系统，如HIS、EMR等。这些系统间的数据格式、存储⽅式各异，不便于直接采集和整合，给数据上报⼯作带来了较⼤困难。'
        },
        { type: 'text', value: '上报任务繁重：时效性与准确性要求⾼' },
        {
            type: 'text2', value: '医疗机构病案⾸⻚上报任务繁重，医务⼈员需处理⼤量数据，并且各平台对上报时效性要求较⾼。这种⾼压⼒的⼯作状态不仅增加了医务⼈员的负担，也对数据上报的准确性和及时性提出了更⾼要求。'
        },
        { type: 'text', value: '数据审验挑战：质量控制难度⼤' },
        {
            type: 'text2', value: '由于院内业务系统病案⾸⻚历史数据可能存在质量不⾼的情况，如数据缺失、错误等，医疗机构在数据上报前需进⾏严格的审验和质量控制。这⼀过程不仅耗时耗⼒，也⼤⼤降低了数据上报的效率。'
        },
        { type: 'title', value: '⽅案介绍' },
        {
            type: 'text', value: '普康数据上报解决⽅案专注病案⾸⻚，致⼒于缓解医疗机构中来⾃国家、省市病案⾸⻚数据上报任务的压⼒，设计集成式的、可灵活配置的的数据集成上报解决⽅案，将所有上报平台集成到⼀起统⼀管理，采⽤配置化的⽅式快速地经不同来源的数据进⾏整合、清洗、转化和上报。'
        },
        { type: 'title', value: '⽅案亮点' },
        { type: 'text', value: '多平台集成式统⼀管理' },
        { type: 'text2', value: '普康数据上报解决⽅案打破平台之间的壁垒，实现集中化、⼀站式的管理，上报员可以在⼀个统⼀的界⾯和系统中，轻松完成所有平台的上报⼯作，极⼤地降低⼯作成本，提⾼⼯作效率。' },
        { type: 'text', value: '上报内容配置化管理' },
        {
            type: 'text2', value: '普康数据上报解决⽅案实现了上报内容的配置化管理，可通过配置平台信息、上报字段、字典范围和映射关系进⾏全⾯配置化管理。通过这种可配置化的管理，能够最⼤程度地满⾜多样化的业务需求，确保上报的内容准确、及时且符合实际应⽤。'
        },
        { type: 'text', value: '配置化规则检验引擎' },
        {
            type: 'text2', value: '普康数据上报解决⽅案⾃研配置化规则校验引擎模块，帮助医疗机构快速⾃定义上报字段的值域、格式、必填项并基于字段建⽴复杂表达式关系校验规则。'
        },
        { type: 'title', value: '⽅案价值' },
        { type: 'text', value: '助⼒提⾼病案⾸⻚上报效率' },
        {
            type: 'text2', value: '普康数据上报解决⽅案实现了多平台集成式统⼀管理，它打破了不同平台间的隔阂，实现了对多个平台的集中⾼效管控，有效提⾼了上报员操作和上报的效率。'
        },
        { type: 'text', value: '实现标准化术语管理' },
        {
            type: 'text2', value: '普康数据上报解决⽅案实现了根据不同上报平台的变化，轻松配置各项上报内容，适配不同上报平台，为医院提供了更科学、⾼效的数据管理⼿段，有⼒推动其在数字化时代的竞争⼒提升和持续发展。'
        },
        { type: 'title', value: '信息化平台' },
        { type: 'img', value: 'detail5' }
    ]
}